import { render, staticRenderFns } from "./caso-extraordinario.vue?vue&type=template&id=afaf1f9a&"
import script from "./caso-extraordinario.vue?vue&type=script&lang=ts&"
export * from "./caso-extraordinario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports